import { useNavigate } from "react-router-dom";

export default function FMHero() {
  const navigate = useNavigate();

  return (
    <section
      id="fm-hero"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "100vh" }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/78e8eb7c5f3ab4032761656c9d5736b2.jpg"
          alt="Premium OEM engine block casting and precision machining foundry facility"
          className="w-full h-full object-cover object-top"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, rgba(255,248,235,0.92) 0%, rgba(255,243,220,0.82) 40%, rgba(255,255,255,0.55) 100%)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 flex flex-col justify-center" style={{ minHeight: "100vh", paddingTop: "120px", paddingBottom: "80px" }}>
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 self-start"
          style={{
            background: "rgba(217,119,6,0.1)",
            border: "1px solid rgba(217,119,6,0.3)",
          }}
        >
          <i className="ri-settings-3-fill text-xs" style={{ color: "#D97706" }} />
          <span
            className="text-xs font-semibold tracking-widest uppercase"
            style={{ color: "#D97706", letterSpacing: "0.2em" }}
          >
            Foundry &amp; Precision Machining
          </span>
        </div>

        {/* Headline */}
        <h1
          className="font-black leading-none mb-6"
          style={{
            fontSize: "clamp(2.6rem, 5.5vw, 5rem)",
            color: "#1a1a1a",
            letterSpacing: "-0.01em",
            maxWidth: "820px",
          }}
        >
          Premium OEM{" "}
          <span style={{ color: "#D97706" }}>Engine Block</span>
          <br />
          Casting &amp; Precision
          <br />
          Machining
        </h1>

        {/* Subheadline */}
        <p
          className="text-lg font-light leading-relaxed mb-10"
          style={{ color: "rgba(30,20,5,0.65)", maxWidth: "620px", lineHeight: "1.8" }}
        >
          From reverse engineering to mass production — we replicate any engine block
          to <strong style={{ color: "#1a1a1a", fontWeight: 700 }}>1:1 OEM specification</strong> without
          original blueprints. Custom casting solutions for global B2B partners, backed
          by ISO 9001:2015 certification and CMM-grade quality control.
        </p>

        {/* Stats row */}
        <div className="flex flex-wrap gap-8 mb-12">
          {[
            { value: "15+", label: "Years Foundry Experience" },
            { value: "3D", label: "Reverse Engineering" },
            { value: "ISO", label: "9001:2015 Certified" },
            { value: "CMM", label: "Precision Inspection" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span
                className="font-black"
                style={{ fontSize: "2rem", color: "#D97706", lineHeight: 1 }}
              >
                {stat.value}
              </span>
              <span
                className="text-xs font-semibold tracking-widest uppercase mt-1"
                style={{ color: "rgba(30,20,5,0.5)", letterSpacing: "0.14em" }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* CTA buttons */}
        <div className="flex flex-wrap gap-4">
          <a
            href="#fm-contact"
            className="flex items-center gap-2 px-8 py-4 rounded-xl font-bold tracking-widest text-sm text-white transition-all duration-200 hover:brightness-110 active:scale-95 cursor-pointer whitespace-nowrap"
            style={{
              background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
              letterSpacing: "0.13em",
              textDecoration: "none",
            }}
          >
            <i className="ri-mail-send-line" />
            Request a Custom Quote
          </a>
          <a
            href="#fm-capabilities"
            className="flex items-center gap-2 px-8 py-4 rounded-xl font-bold tracking-widest text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{
              background: "rgba(30,20,5,0.06)",
              border: "1.5px solid rgba(30,20,5,0.18)",
              color: "#1a1a1a",
              textDecoration: "none",
              letterSpacing: "0.13em",
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.background = "rgba(217,119,6,0.08)";
              (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(217,119,6,0.4)";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.background = "rgba(30,20,5,0.06)";
              (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(30,20,5,0.18)";
            }}
          >
            <i className="ri-arrow-down-line" />
            Explore Capabilities
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <div
          className="w-px h-12"
          style={{ background: "linear-gradient(to bottom, rgba(217,119,6,0.6), transparent)" }}
        />
        <span
          className="text-xs tracking-widest uppercase"
          style={{ color: "rgba(30,20,5,0.35)", letterSpacing: "0.2em", fontSize: "9px" }}
        >
          Scroll
        </span>
      </div>
    </section>
  );
}
